import React, { useEffect, useState } from 'react';

//Style
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './SideMenuTrips.css';
import cx from 'classnames';

// Component
import Link from '../../Link';
import history from '../../../core/history';

const SideMenuTrips = ({ menuItemOne, menuItemTwo, menuItemThree, linkOne, linkTwo, linkThree, handleClick }) => {
  const [location, setLocation] = useState('');

  useEffect(() => {
    if (history.location) {
      setLocation(history.location?.pathname);
    }
  }, [location, history.location?.pathname]);

  const handleSelect = async () => {
    await handleClick();
  };

  return (
    <div>
      <ul className={cx('sideMenuBorder')}>
        <li className={cx('sideMenuBorderPadding', { ['menuActive']: location === linkOne })} onClick={handleSelect}        >
          <Link to={linkOne} className={cx('sideNavitem', 'sideNav')}>
            {menuItemOne}
          </Link>
        </li>
        <li className={cx('sideMenuBorderPadding', { ['menuActive']: location === linkTwo })} onClick={handleSelect}        >
          <Link to={linkTwo} className={cx('sideNavitem', 'sideNav')}>
            {menuItemTwo}
          </Link>
        </li>
        <li className={cx('sideMenuBorderPadding', { ['menuActive']: location === linkThree })} onClick={handleSelect}        >
          <Link to={linkThree} className={cx('sideNavitem', 'sideNav')}>
            {menuItemThree}
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default withStyles(s)(SideMenuTrips);